module.exports = __webpack_public_path__ + "img/w3_circle_grid_dark.d386ebd8.d386ebd8.png";